import React from "react";
import LegalShell from "../../components/LegalShell";

export default function Cookies() {
    return (
        <LegalShell title="Cookie Policy" tagline="What we store on your device, and why." testId="page-cookies">
            <h2 className="display text-xl font-black">1. What is a cookie?</h2>
            <p>A cookie is a small piece of data a website stores in your browser. Some cookies are strictly necessary for the site to work; others help us understand how the site is used, or remember your preferences.</p>

            <h2 className="display text-xl font-black">2. What footsie uses</h2>
            <ul className="list-disc pl-5 space-y-1">
                <li><strong>Session cookie</strong> — an HTTP-only, secure cookie holding your login token. Without it you cannot stay logged in. Deleted when you log out.</li>
                <li><strong>Consent flag</strong> — a small entry in <em>localStorage</em> (not a cookie) recording that you dismissed the cookie banner and accepted our Terms and Age Gate. Removing it will make the banner reappear.</li>
                <li><strong>Stripe</strong> — when you visit the checkout flow, Stripe sets its own cookies for fraud prevention. These are governed by <a className="underline" href="https://stripe.com/cookies-policy/legal" target="_blank" rel="noreferrer">Stripe&apos;s cookie policy</a>.</li>
            </ul>

            <h2 className="display text-xl font-black">3. What footsie does NOT use</h2>
            <ul className="list-disc pl-5 space-y-1">
                <li>No third-party advertising cookies.</li>
                <li>No cross-site tracking pixels.</li>
                <li>No analytics SDKs that fingerprint your device.</li>
            </ul>

            <h2 className="display text-xl font-black">4. Managing cookies</h2>
            <p>You can clear cookies at any time from your browser settings. Doing so will log you out and reset the cookie banner. Blocking the session cookie entirely will prevent you from logging in.</p>

            <h2 className="display text-xl font-black">5. Changes</h2>
            <p>If we change what we store, we will update this page and bump the version shown in <a href="/legal/changelog" className="underline">the changelog</a>.</p>

            <h2 className="display text-xl font-black">6. Contact</h2>
            <p>Questions about this policy? Email <a className="underline" href="mailto:privacy@feetrate.app">privacy@feetrate.app</a>.</p>
        </LegalShell>
    );
}
